import { IProductBrandProps } from "../components";

export const mockedProductBrand: IProductBrandProps = {
  iconData: {
    type: "svg-icon",
    data: {
      icon: "NikeIcon",
    },
  },
  brand: { href: "/", text: "Nike" },
  product: { href: "/", text: "SolarGlide 3 Schoenen" },
  feedback: { rating: 4.5, reviews: 15, link: { href: "/" } },
  useHeading: "h1"
};
